import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-custom-button',
  standalone: true,
  imports: [CommonModule, MatRippleModule, MatIconModule, MatTooltipModule, MatProgressSpinnerModule],
  templateUrl: './custom-button.component.html',
  styleUrls: ['./custom-button.component.scss'],
  host: {
    '[style.width]': 'width === "100%" ? "100%" : ""'
  }
})
export class CustomButtonComponent {
  @Input() variant:
    | 'flat'
    | 'stroked'
    | 'icon'
    | 'default'
    | 'close'
    | 'link'
    | 'secondary' = 'flat';
  @Input() color: 'primary' | 'warn' = 'primary';
  @Input() disabled: boolean = false;
  @Input() label?: string;
  @Input() iconName?: string;
  @Input() width: string = 'auto';
  @Input() tooltip?: string;
  @Input() height: string = '40px';
  @Input() type: 'button' | 'submit' = 'button';
  @Input() loading: boolean = false;

  @Output() buttonClick = new EventEmitter<MouseEvent>();

  onClick(event: MouseEvent) {
    if (!this.disabled && !this.loading) {
      this.buttonClick.emit(event);
    }
  }
}
